import { useEffect, useState } from "react";

/** Browser connectivity is a hint, not proof that the service is reachable. */
export function useOffline() {
	const [offline, setOffline] = useState(false);
	useEffect(() => {
		const sync = () => setOffline(!navigator.onLine);
		sync();
		window.addEventListener("online", sync);
		window.addEventListener("offline", sync);
		return () => {
			window.removeEventListener("online", sync);
			window.removeEventListener("offline", sync);
		};
	}, []);
	return offline;
}
